import React, { lazy } from "react";
import { createBrowserRouter, redirect, useParams } from "react-router-dom";
import { checkRedirectToOldWcip } from "@/utils/common";
const LazyWcipLoginform = lazy(() => import("@/pages/WcipLoginform"));
// import WcipLoginform  from '@/pages/WcipLoginform'
const LazyTRCLoginForm = lazy(() => import("@/pages/TRCLoginForm"));
const CampaignLoginForm = lazy(() => import("@/pages/CampaignLoginForm"));
const LazyCVRSLoginForm = lazy(() => import("@/pages/CVRSLoginForm"));
const LazyWebcastLoginForm = lazy(() => import("@/pages/WebcastLoginForm"));
const LazySmsOtp = lazy(() => import("@/components/SmsOtp"));
const LazyWcipForgotForm = lazy(() => import("@/pages/WcipForgotForm"));
const LazyWcipCreatAccountForm = lazy(() =>
    import("@/pages/WcipCreatAccountForm")
);
const CSSPDashBorard = lazy(() => import("@/pages/CSSPDashBorard"));
const LazyCSSPForgotLoginForm = lazy(() => import("@/pages/CSSPForgotFlow"));
const LazyCSSPChangePWLoginForm = lazy(() =>
    import("@/pages/CSSPChangePWFlow")
);
const LazyCSSPLoginForm = lazy(() => import("@/pages/CSSPLoginForm"));
const LazyCSSPAssoFlow = lazy(() => import("@/pages/CSSPAssoFlow"));
const LazyMemberLogin = lazy(() => import("@/pages/MemberLogin"));
const ForgotPasswordFlow = lazy(() => import("@/pages/ForgotPasswordFlow"));
const ThreeInOneForm = lazy(() => import("@/pages/ThreeInOneForm"));
const ThreeInOneFormBetting = lazy(() =>
    import("@/pages/ThreeInOneFormBetting")
);
const CookieGen = lazy(() =>
    import("@/pages/CookieGen")
);
// const NotificationOfApp = lazy(() => import("@/pages/NotificationOfApp"));
import NotificationOfApp from '@/pages/NotificationOfApp'
import NotificationOfAppAssociate from "@/pages/NotificationOfAppAssociate"

const MissingMobileOfApp = lazy(() => import("@/pages/MissingMobileOfApp"));
const ThreeInOneChange = lazy(() => import("@/pages/ThreeInOneChange"));
const WcipDashBorard = lazy(() => import("@/pages/WcipDashBorard"));
const Success = lazy(() => import("@/components/Success"));
const ChangePwd = lazy(() => import("@/pages/ChangePassword"));
const ChangeMember = lazy(() => import("@/pages/ChangeMember"));
const MemberForgot = lazy(() => import("@/pages/MemberForgot"));
const NotificationOfMember = lazy(() => import("@/pages/NotificationOfMember"));
const OTPMaxFail = lazy(() => import("@/pages/NotificationOfMember/OTPMaxFail"));
const NoContacts = lazy(() =>
    import("@/pages/NotificationOfMember/NoContacts")
);
const MemberLocked = lazy(() =>
    import("@/pages/NotificationOfMember/MemberLocked")
);
const MagicLinkSendSuccess = lazy(() =>
    import("@/pages/NotificationOfMember/MagicLinkSendSuccess")
);
// const ServiceIssues = lazy(() =>
//     import("@/pages/NotificationOfMember/ServiceIssues")
// );
import ServiceIssues from "@/pages/NotificationOfMember/ServiceIssues"
const HKJCTVUpdateMobile = lazy(() => import("@/pages/HKJCTVUpdateMobile"));
const ProfileMaintenance = lazy(() => import("@/pages/ProfileMaintenance"));
// const NotFoundPage = lazy(() => import('@/pages/NotFoundPage'));
const RedirectComponent = ({ children, url, redirect = null }) => {
    let oldUrl = url;
    const { lang } = useParams();
    if (redirect) {
        window.location.href = `${redirect}` + window.location.search;
        return <></>;
    }
    if (url.indexOf("Login/Webcast") > 0) {
        oldUrl = `${url}/${lang}`;
    }
    if (window.globalConfig.VITE_REDIRECT_TO_OLD_WCIP) {
        checkRedirectToOldWcip(oldUrl, lang);
        return <></>;
    } else {
        return children;
    }
};

const Genericerror = () => {
    return (
        <div style={{
            width: '100%',
            height: '300px',
            textAlign: 'left',
            padding: '125px 0',
            fontSize: 'large',
            color: '#666',
            lineHeight: '25px',
            borderBottom: '1px solid #ccc',
            marginBottom: '12px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
        }}>
            <div style={{ width: '320px' }}>
                <div>Service Inaccessible, please call 1818</div>
                <div>服務未能提供，請致電1818</div>
            </div>
        </div>
    )
}

const router = createBrowserRouter([
    {
        path: "/",
        loader: () => redirect("/en-us/login?EP=BS"),
    },
    {
        path: "/login/callback",
        element: <>success</>,
    },
    {
        path: "/:lang/login",
        children: [
            {
                index: true,
                element: (
                    <RedirectComponent url="/Loginform.aspx">
                        <LazyWcipLoginform />
                    </RedirectComponent>
                ),
            },
            {
                path: "trc",
                element: (
                    <RedirectComponent url="/loginformtrc.aspx" redirect="racingclub">
                    </RedirectComponent>
                ),
            },
            {
                path: "racingclub",
                element: (
                    <RedirectComponent url="/loginformtrc.aspx">
                        <LazyTRCLoginForm />
                    </RedirectComponent>
                ),
            },
            {
                path: "campaign",
                element: (
                    <RedirectComponent url="/loginformcampaign.aspx">
                        <CampaignLoginForm />
                    </RedirectComponent>
                ),
            },
            {
                path: "cvrs",
                element: (
                    <RedirectComponent url="/loginformCVRS.aspx" redirect="bookingrc">
                    </RedirectComponent>
                ),
            },
            {
                path: "bookingrc",
                element: (
                    <RedirectComponent url="/loginformCVRS.aspx">
                        <LazyCVRSLoginForm />
                    </RedirectComponent>
                ),
            },
            {
                path: "webcast",
                element: (
                    <RedirectComponent url="/Account/Login/Webcast">
                        <LazyWebcastLoginForm />
                    </RedirectComponent>
                ),
            },
            {
                path: "member",
                element: <LazyMemberLogin></LazyMemberLogin>,
            },
            // {
            //     path: "cssp",
            //     element: <LazyCSSPLoginForm></LazyCSSPLoginForm>,
            // },
        ],
    },
    {
        path: "/:lang/change/cssp",
        element: <CSSPDashBorard></CSSPDashBorard>,
        children: [
            {
                index: true,
                element: (
                    <LazyCSSPChangePWLoginForm></LazyCSSPChangePWLoginForm>
                ),
            },
            {
                path: "update-error",
                element: <LazyCSSPChangePWLoginForm />,
            },
        ],
    },
    {
        path: "/:lang/change/member",

        children: [
            {
                index: true,
                element: <ChangeMember></ChangeMember>,
            },
            {
                path: "notification",
                element: <NotificationOfMember />,
            },
            {
                path: "noContacts",
                element: <NoContacts />,
            },
            {
                path: "otpMaxFail",
                element: <OTPMaxFail />,
            },
            {
                path: "serviceIssues",
                element: <ServiceIssues />,
            },
            {
                path: "locked",
                 element:  <MemberLocked />
            }
        ],
    },
    {
        path: "/:lang/change/mobileApp",
        children: [
            {
                index: true,
                element: <ThreeInOneChange />,
            },
            {
                path: "notification",
                element: (
                    <NotificationOfApp
                        title="LB_CHANGE_SUCCESS_TITLE"
                        type="change"
                    />
                ),
            },
            {
                path: "missingMobile",
                element: <MissingMobileOfApp />,
            },
        ],
    },
    {
        path: "/:lang/change",
        element: <WcipDashBorard></WcipDashBorard>,
        children: [
            {
                index: true,
                element: <ChangePwd></ChangePwd>,
            },
            // {
            //   path: 'smsotp',
            //   element: <LazySmsOtp></LazySmsOtp>
            // },
            // {
            //   path: 'success',
            //   element: <Success></Success>
            // }
        ],
    },
    {
        path: "/:lang/forgot/cssp",
        element: <CSSPDashBorard></CSSPDashBorard>,
        children: [
            {
                index: true,
                element: <LazyCSSPForgotLoginForm />,
            },
            {
                path: "update-error",
                element: <LazyCSSPForgotLoginForm />,
            },
        ],
    },
    {
        path: "/:lang/forgot/member",
        children: [
            {
                index: true,
                element: <MemberForgot />,
            },
            {
                path: "notification",
                element: <NotificationOfMember />,
            },
            {
                path: "noContacts",
                element: <NoContacts />,
            },
            {
                path: "otpMaxFail",
                element: <OTPMaxFail />,
            },
            {
                path: "mcSuccessful",
                element: <MagicLinkSendSuccess />,
            },
            {
                path: "serviceIssues",
                element: <ServiceIssues />,
            },
        ],
    },
    {
        path: "/:lang/forgot/mobileApp",
        children: [
            {
                index: true,
                element: <ThreeInOneForm />,
            },
            {
                path: "notification",
                element: <NotificationOfApp />,
            },
            {
                path: "missingMobile",
                element: <MissingMobileOfApp />,
            },
        ],
    },
    {
        path: "/:lang/UpdateMobile/HKJCTV",
        element: <HKJCTVUpdateMobile></HKJCTVUpdateMobile>,
    },
    {
        path: "/:lang/forgot",
        element: <WcipDashBorard></WcipDashBorard>,
        children: [
            {
                index: true,
                element: <LazyWcipForgotForm />,
            },
            // {
            //   path: 'success',
            //   element: <Success></Success>
            // },
            {
                path: "smsotp",
                element: <LazySmsOtp></LazySmsOtp>,
            },
            {
                path: "apiTestPage",
                element: <ForgotPasswordFlow></ForgotPasswordFlow>,
            },
        ],
    },
    {
        path: "/:lang/update-error",
        element: <WcipDashBorard></WcipDashBorard>,
        children: [
            {
                index: true,
                element: <Success error></Success>,
            },
        ],
    },
    {
        path: "/:lang/profile-maintenance",
        element: <WcipDashBorard></WcipDashBorard>,
        children: [
            {
                index: true,
                element: <ProfileMaintenance></ProfileMaintenance>,
            },
        ],
    },
    {
        path: "/:lang/associate",
        element: <WcipDashBorard></WcipDashBorard>,
        children: [
            {
                index: true,
                element: <LazyWcipCreatAccountForm></LazyWcipCreatAccountForm>,
            },
        ],
    },
    // activate online betting service
    {
        path: "/:lang/associate/mobileApp",
        children: [
            {
                index: true,
                element: <ThreeInOneFormBetting />,
            },
            {
                path: "notification",
                element: (
                    <NotificationOfAppAssociate
                    // title="ACTIVATION_SUCCESS"
                    // type="betting"
                    />
                ),
            },
        ],
    },
    {
        path: "/:lang/associate/cssp",
        element: <CSSPDashBorard></CSSPDashBorard>,
        children: [
            {
                index: true,
                element: <LazyCSSPAssoFlow />,
            },
            {
                path: "update-error",
                element: <LazyCSSPAssoFlow />,
            },
        ],
    },
    {
        path: "/:lang/genericerror",
        element: <WcipDashBorard></WcipDashBorard>,
        children: [
            {
                index: true,
                element: <Genericerror />,
            },
        ],
    },
    {
        path: "/custProIn",
        element: <CookieGen />,
    },
    // 显式定义404路由
    {
        path: "*",
        // element: <NotFoundPage />,
        loader: () => {
            const url = "https://common.hkjc.com/maint/404.html";
            window.location.href = url;
        },
    },
]);

export default router;
